
export {ClayIconSpriteContext} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$icon.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$icon.js';export default __x__;